import { Component, ElementRef } from '@angular/core';
import { BaseDynamicListDesignerComponent } from './base.dynamic.list.component';
import { DesignerSelectItem } from 'app/private/sxfdesigner/types/product.type';
import { DesignAttributeType, RuleAttribute } from 'app/private/sxfdesigner/types/designer-attribute-type';

@Component({
    selector: 'sx-quotationresult-designer',
    templateUrl: './quotationResultDesigner.component.html'
})

export class SxQuotationResultDesigner extends BaseDynamicListDesignerComponent {
    interactionRules: DesignerSelectItem[] = [];

    constructor(container: ElementRef) {
        super(container);
        this.type='SxQuotationResult'
    }

    get jsonListProperty(): string {
        return 'customButtons';
    }

    loadDefaults(): void {
        super.loadDefaults();
        this.controlContext.selectedOptionRule = '';
    }

    loadState(rootBranch: any) {
        super.loadState(rootBranch);
        this.controlContext.selectedOptionRule = rootBranch['selectedOptionRule'];
    }

    getDesignerInfo(): any {
        const info = super.getDesignerInfo();
        info.selectedOptionRule = this.attributes
            .find(item => item.name === 'selectedOptionRule')
            .value;
        return info;
    }
    buildAttributes(): void {
        super.buildAttributes();
        const translationAttr = new DesignAttributeType(
            this.controlContext,
            'string',
            'translation',
            'Translation for Quote Result Label'
        );

        this.interactionRules = this.designerContext.product.interactionRules;
        const selectedOptionRuleValue = 
            new RuleAttribute(this.controlContext, this.interactionRules, 'selectedOptionRule', 'Selected OptionRule');

        this.attributes.push(translationAttr, selectedOptionRuleValue);
    }

}



// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/private/sxfdesigner/components/designers/layout/flow-actions/quotationResultDesigner.component.ts